import { Component, OnInit } from '@angular/core';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  public api = api;
  public env = environment;
  public menu: any[] = [];
  isCollapsed = false;

  constructor(public _common: CommonService,
    public _shared: SharedService,
    public service: WebserviceService) {
    this._shared.sharedSideMenu.subscribe(data => {
      this.menu
      let sideM = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
      let sideRaceM7 = (localStorage.getItem(`${this.env.panel}sideRaceMenu7`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu7`) as any) : [];
      let sideRaceM4339 = (localStorage.getItem(`${this.env.panel}sideRaceMenu4339`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu4339`) as any) : [];
      let menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];

      let dts = [...sideM, ...sideRaceM7, ...sideRaceM4339];
      dts = dts.sort((a: any, b: any) => {
        let fd = new Date(b.open_date) as any; let ld = new Date(b.open_date) as any;
        return (fd - ld);
      });

      let ids: any[] = [];
      dts.forEach((element: any) => {
        ids.push({ id: element.competition_id, name: element.competition_name });
      });
      ids = [... new Set(ids.map(JSON.stringify as any))].map(JSON.parse as any)

      let tempMenu: any[] = [];
      const mGrouped = this._common.groupBy(dts, (dat: any) => dat.event_type_id);
      menu.forEach((menuEle: any, i: any) => {
        if (mGrouped.get(menuEle.id))
          tempMenu.push({ id: menuEle.id, name: menuEle.name, data: mGrouped.get(menuEle.id), child: [] })
      });

      tempMenu.forEach((tEle) => {
        const grouped = this._common.groupBy(tEle.data, (dat: any) => dat.competition_id);
        ids.forEach((element) => {
          if (grouped.get(element.id))
            tEle.child.push({ name: element.name, data: grouped.get(element.id) })
        });
      });

      this.menu = tempMenu;
      // console.log(this.menu);
    })
  }

  ngOnInit(): void {
    //side menu toggle js
    $(document).on('click', '#side-menu a, .scrollto', (e: any) => {
      // console.log(e.target.classList.value.includes('menu-link-redi'));
      // console.log(e.target.classList.value);

      if (e.target.classList.value.includes('menu-link-redi')) {
        // e.preventDefault();
        // e.stopPropagation();
        $('body').removeClass("sidebar-enable");
      } else {
        $('body').addClass("sidebar-enable");
      }

    });

    // this.getRaceListData(7);
    // this.getRaceListData(4339);

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getRaceListData(id: any) {
    this.getServices().Get(`${this.env.baseUrl + this.api.raceListG}/${id}`).subscribe(
      (res) => {
        if (res.status == true) {
          res.data.race = this._common.UTC_to_Local_timeZone(res.data.race);
          res.data.race.forEach((element: any) => {
            // element["exposure"] = 0;
            element["event_type_id"] = id;
            element["runner"] = [];
          });

          localStorage.removeItem(`${this.env.panel}sideRaceMenu${id}`);
          localStorage.setItem(`${this.env.panel}sideRaceMenu${id}`, JSON.stringify(res.data.race));
          this._shared.emitSideMenu(res.data.race);

        }
      },
      (err) => {
        console.log(err);
      });
  }

  preventClick(e: any) {
    e.stopPropagation();
  }
  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
